import React, { PureComponent } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, ButtonGroup, Checkbox } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import { orange } from '@mui/material/colors';

const weekDays = [
  { name: 'MON', value: 0 },
  { name: 'TUE', value: 1 },
  { name: 'WED', value: 2 },
  { name: 'THU', value: 3 },
  { name: 'FRI', value: 4 },
  { name: 'SAT', value: 5 },
  { name: 'SUN', value: 6 },
];

class WeekDaysSelect extends PureComponent {
  handleChange = e => {
    const { value, onChange } = this.props;
    const selectedDay = Object.keys(value)[e.target.value];
    const days = value;
    if (days[selectedDay] === true) {
      days[selectedDay] = false;
    } else {
      days[selectedDay] = true;
    }
    onChange(days);
  };

  render() {
    const { value, classes } = this.props;
    return (
      <FormGroup className={classes.form}>
        <ButtonGroup
          className={classes.buttons}
          variant="text"
          color="primary"
          size="small"
        >
          {weekDays.map((day) => (
            <Button
              size="small"
              key={day.value}
              classes={{
                root: value[Object.keys(value)[day.value]]
                  ? classes.selected
                  : classes.rootButton,
              }}
            >
              <FormControlLabel
                className={classes.label}
                control={
                  <Checkbox
                    classes={{
                      root: classes.checkbox,
                    }}
                    icon={<></>}
                    checkedIcon={<></>}
                    checked={value[Object.keys(value)[day.value]]}
                    onChange={this.handleChange}
                    name={day.name}
                    value={day.value}
                  />
                }
                label={day.name}
              />
            </Button>
          ))}
        </ButtonGroup>
      </FormGroup>
    );
  }
}

const styles = () => ({
  form: { display: 'flex' },
  label: {
    width: '100%',
    justifyContent: 'center',
    marginRight: '10px',
  },
  checkbox: {
    left: '20px',
  },
  rootButton: {
    width: '50px',
  },
  selected: {
    width: '50px',
    background: orange[300],
    '&:hover': {
      background: orange[200],
    },
  },
  buttons: {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
});

export default withStyles(styles)(WeekDaysSelect);
